class Service {
  constructor(data, index) {
    this.data = data;
    this.index = index; // Vrstni red/index od 0 do .length

    this.opened = false;

    this.ww = screen.width;
    this.wh = screen.height;

    this.responsive = {
      xl: {
        height: 410,
        width: 480,
        inRow: 3
      },
      lg: {
        height: 300,
        width: 340,
        inRow: 3
      },
      md: {
        width: 340,
        height: 300,
        inRow: 2
      },
      sm: {
        width: 300,
        height: 250,
        inRow: 2
      },
      xs: {
        width: 300,
        height: 250,
        inRow: 1
      }
    };
    this.currentViewport = this.getCurrentViewport();
  }

  setOpened() {
    this.opened = true;
  }

  windowResize() {
    this.ww = screen.width;
    this.wh = screen.height;
    this.currentViewport = this.getCurrentViewport();
    this.getStyleObject();
  }

  getStyleObject() {
    if (this.opened)
      return {};

    var image = "/static/storitve/" + this.data.image;

    return {
      background: {
        "background-image": "url(" + image + ")"
      },
      element: {
        top: this.yOffset(this.data.y) + "px",
        left: this.xOffset(this.data.x[this.currentViewport]),
        opacity: this.data.opacity
      },
      title: {
        "font-size": this.data.fontSize,
        "letter-spacing": this.data.charSpacing + "px"
      }
    };
  }

  yOffset(y) {
    if (this.currentViewport == "sm" || this.currentViewport == "md") {
      var y = Math.floor(this.index / 2) * this.responsive[this.currentViewport].height; // 20 for margin
      if (this.data.x[this.currentViewport] == 1) {
        y = y + this.responsive[this.currentViewport].height / 2;
      }

      return y;
    } else if (this.currentViewport == "xs")
      return this.index * this.responsive[this.currentViewport].height + 20; // 20 for margin
    else
      return this.data.y[this.currentViewport];
  }

  xOffset(position) {
    // Position can be either 0, 1 ,2
    // 0 means far left, 1 in the middle and 2 far right
    // Tukaj bi morali izračunati X pozicijo elementa na strani
    // Upoštevaš širino ekrana, širino elementa, razmake vmes
    // Če trije elementi ne gredo v vrsto, jih moraš repozicionirati
    const boxWidth = this.responsive[this.currentViewport].width
    const rowCount = this.responsive[this.currentViewport].inRow

    var x = position * boxWidth;

    /*if (this.currentViewport == "lg") {
      // Razmak na obeh robovih ekrana enak - boxi so skupaj
      var margin = (this.ww - (rowCount * boxWidth)) / 2;
    } else {
      // Razmak enak med vsemi boxi
      var margin = ((this.ww - (rowCount * boxWidth)) / (rowCount + 1)) * (position + 1);
    }*/

    var margin = (this.ww - (rowCount * boxWidth)) / 2;

    return x + margin + "px";
  }

  getCurrentViewport() {
    const viewports = {
      xl: 1440,
      lg: 1140,
      md: 800,
      sm: 600,
      xs: 300
    }

    for (const vw_name in viewports) {
      if (viewports[vw_name] <= this.ww)
        return vw_name;
    }

    return "xs";
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/components/Services/Service.js